module.exports = __webpack_public_path__ + "static/media/blood-badge.099dc69a.svg";